import React, { FunctionComponent, ReactNode } from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import IconDone from '@views/static/check.svg';

import _scrollToTop from '@helpers/scroll-top';

const IconWrapper = styled.div`
  max-width: 80px;
`;

const ModalTextWrapper = styled.div`
  padding: 1rem 0;
  text-align: center;
`;

export type DialogProps = {
  open: boolean;
  onClose: () => void;
};

const Dialog: FunctionComponent<DialogProps> = ({ open, onClose }) => (
  <Modal show={open} onHide={onClose} size="sm" centered>
    <Modal.Body>
      <div className="d-flex justify-content-between">
        <Modal.Title as="h4" className="mb-2" />
        <button type="button" className="icon-close" onClick={onClose} />
      </div>

      <ModalTextWrapper>
        <div className="d-flex justify-content-center mb-4">
          <IconWrapper>
            <IconDone width={100} />
          </IconWrapper>
        </div>
        Yêu cầu báo giá của anh/chị đã được gửi. Sơn Thuỷ sẽ sớm gửi thông tin
        báo giá đến quý anh/chị.
      </ModalTextWrapper>
    </Modal.Body>
  </Modal>
);

export default Dialog;
